import { entryStatus } from '@/db/schema/_types'
import { account, AccountResolved } from '@/db/schema/account'
import { user } from '@/db/schema/user'
import { decimal, integer, PgColumn, pgEnum, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'

export const transferType = pgEnum('transfer_type', [
  'transfer_cashout', // Auszahlungen
  'transfer_account_opening', // Account Eröffnung
  'transfer_deposit', // Rückstellung
  'transfer', // Überweisung
])

export const transfer = pgTable('transfer', {
  id: serial('id').primaryKey(),
  migrationId: text('migration_id'), // Migration ID
  created: timestamp().defaultNow().notNull(),
  updated: timestamp().defaultNow().notNull(),
  issued: timestamp().defaultNow().notNull(),
  createdBy: integer('created_by')
    .notNull()
    .references((): PgColumn => user.id),
  name: text('name').notNull(),
  amount: decimal('amount').notNull().default('0'),
  status: entryStatus().notNull(),
  from: integer('from')
    .references((): PgColumn => account.id)
    .notNull(),
  to: integer('to')
    .references((): PgColumn => account.id)
    .notNull(),
})

export type Transfer = typeof transfer.$inferSelect
export type InsertTransfer = typeof transfer.$inferInsert
export type TransferResolved = { transfer: Transfer; from: AccountResolved; to: AccountResolved }
export type UpdateTransfer = Partial<Transfer>
